import React from 'react';
import { Radio } from 'antd';
import PropTypes from 'prop-types';
import { basisProImg as BasisProImg } from 'theme/icon';
import SelectBasis from 'components/RouteCard/control/editRoute/control/selectBasis';

import styles from './styles.scss';

const RadioGroup = Radio.Group;

const link = (
  <span className={styles.container}>
    <BasisProImg alt="" />
    <a target="_blank" rel="noreferrer" href="https://basis.myseldon.com" className={styles.link}>
      Seldon.Basis
    </a>
  </span>
);

export default class TenderParticipantsSelectFirm extends React.PureComponent {
  static propTypes = {
    saveFirm: PropTypes.func.isRequired,
    isParticipantsActive: PropTypes.bool.isRequired,
  };
  state = {
    value: 1,
  };

  onChange = e => {
    this.setState({
      value: e.target.value,
    });
  };

  render() {
    return (
      <div className={styles.searchBox}>
        <div className={styles.search}>
          <SelectBasis
            selectProperty={{
              cache: false,
            }}
            onSelect={firm => this.props.saveFirm(firm)}
            placeholder="ИНН, ОГРН или название организации"
            searchParticipants={this.state.value === 2}
          />
        </div>
        <RadioGroup className={styles.radio} onChange={this.onChange} value={this.state.value}>
          <Radio value={1}>
            <div className={styles.radioContent}>Из {link}</div>
          </Radio>
          {this.props.isParticipantsActive && <Radio value={2}>Из моих списков</Radio>}
        </RadioGroup>
      </div>
    );
  }
}
